import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import ToggleButtonListItem from '../../../../../../list-items/ToggleButtonListItem';
import { createActions } from '../../../../store';

const spectrumOptions = [
    { value: 'bass spectrum', text: 'Bass' },
    { value: 'wide spectrum', text: 'Wide' }
];

const WaveLayerTypeListItem = memo(({ index, waveType, updateWaveLayerCustomOptions }) => {
    const handleChange = useCallback(
        (value) => updateWaveLayerCustomOptions(index, "waveType", value),
        [index]
    );

    return (
        <ToggleButtonListItem
            text='Spectrum'
            value={waveType}
            onChange={handleChange}
            options={spectrumOptions}
            toolTip={
                <>
                    <p>BASS: Visualize low frequencies.</p>
                    <p>WIDE: Visualize a wide range of frequencies.</p>
                </>
            }
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { waveType } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    return { waveType };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerTypeListItem);
